<template>
  <div>
    <template v-if="data.length">
      <div class="result-item" v-for="(item, index) in data" :key="index">
        <div class="result-item-wrapper">
          <div class="result-avatar">
            <img :src="(item.half_length_portrait||defaultHalfPortrait) | compressImg" alt="">
          </div>
          <div class="result-info">
            <div class="result-title">
              <span>{{item.name}}</span>
              <span class="result-branch" v-if="formatCity(item.city, item.province)">{{formatCity(item.city, item.province)}}</span>
              <span class="result-branch" v-if="item.virtual_type === 1">名誉会员</span>
            </div>
            <div class="result-panel">
              <div class="result-panel-left">
                <div class="result-info-item">
                  <span class="result-info-title">公司：</span>
                  <span class="result-info-content company">{{item.company_name||defaultInfo}}</span>
                </div>
                <div class="result-info-item">
                  <span class="result-info-title">职位：</span>
                  <span class="result-info-content">{{item.job_title_content || formatJobTitles(item.job_title) || defaultInfo}}</span>
                </div>
              </div>
              <div class="result-panel-right">
                <div class="result-info-item">
                  <span class="result-info-title">行业：</span>
                  <span class="result-info-content">{{formatIndustry(item.industry)||defaultInfo}}</span>
                </div>
                <div class="result-info-item">
                  <span class="result-info-title">邮箱：</span>
                  <span class="result-info-content">{{item.email||defaultInfo}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result-line"></div>
      </div>
    </template>
    <template v-else>
      <div class="tip-container">
        <div class="wrapper">
          <span class="iconfont icon-empty"></span>
          <span class="warn-tip">没有找到相关学员</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { formatCity } from '@/util/methods'

import { companyIndustrys, jobTitles } from '@/data/form'
import { defaultHalfPortrait } from '@/data/default'

export default {
  data () {
    return {
      defaultHalfPortrait,
      defaultInfo: '信息缺失'
    }
  },
  props: ['data'],
  methods: {
    formatCity (city, province) {
      return `${formatCity(city, province)}`
    },
    formatIndustry (industry) {
      if (Array.isArray(industry) && industry.length) {
        let companyIndustrysMap = {}
        let string = ''
        companyIndustrys.forEach(item => {
          companyIndustrysMap[item.id] = item
        })
        industry.map(id => companyIndustrysMap[id]).forEach(item => {
          string = string + item.name + ' | '
        })
        return string.substring(0, string.length - 3)
      } else {
        return ''
      }
    },
    formatJobTitles (jobTitle) {
      let map = {}
      jobTitles.forEach(item => {
        map[item.id] = item
      })
      return map[jobTitle] ? map[jobTitle].name : ''
    }
  },
  filters: {
    compressImg (link) {
      return `${link}?x-oss-process=image/resize,m_fill,h_${Math.floor(134 * window.devicePixelRatio)},w_${Math.floor(110 * window.devicePixelRatio)}`
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../style/bulma/app.sass';

.result-item {
  // display: flex;
  // flex-direction: column;
  // align-items: flex-end;
  @include clearfix;
}
.result-item-wrapper {
  display: flex;
  align-items: center;
}
.result-avatar {
  flex: none;
  width: 110px;
  height: 135px;;
  margin-right: 30px;
  border-radius: 3px;
  overflow: hidden;
  @include mobile {
    margin-right: 15px;
    width: 26vw;
    height: auto;
    img {
      width: 100%;
    }
  }
}
.result-info {
  flex-grow: 1;
  padding-top: 20px;
}
.result-title {
  font-size: 24px;
  line-height: 22px;
  font-weight: 600;
  display: flex;
  align-items: center;
  @include mobile {
    font-size: 20px;
    margin-bottom: -12px;
  }
}
.result-branch {
  margin-left: 9px;
  border-radius: 3px;
  background-color: $primary3;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  padding: 1px 7px 1px;
  margin-top: -3px;
  @include mobile {
    font-size: 12px;
    padding: 0 2vw;
  }
}
.result-member {
  margin-left: 9px;
}
.result-panel {
  display: flex;
  justify-content: space-between;
  padding: 20px 0 16px;
  @include mobile {
    flex-wrap: wrap;
  }
}
.result-panel-left {
  width: 274px;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 40px;
    background-color: rgba(233, 233, 233, 0.5);
    @include mobile {
      opacity: 0;
    }
  }
  @include mobile {
    width: 100%;
  }
}
.result-panel-right {
  flex-grow: 1;
  padding-left: 17px;
  @include mobile {
    padding-left: 0;
  }
}
.result-line {
  float: right;
  width: 572px;
  height: 1px;
  margin: 20px 0;
  background-color: rgba(233, 233, 233, 0.5);
  @include mobile {
    width: 100%;
    margin-top: 0;
    margin-bottom: 10px;
  }
}
.result-info-item {
  display: flex;
  margin-bottom: 7px;
  font-size: 17px;
  color: #5E5E5E;
  word-wrap: break-word;
  &:nth-child(2n) {
    margin: 0;
  }
  @include mobile {
    font-size: 14px;
    margin-bottom: 0;
  }
}
.result-info-title {
  flex-shrink: 0;
  color: rgba(154, 154, 154, 1);
  margin-right: -3px;
}
.result-info-content {
  @include limit-line-numbers(1);
  word-break: break-all;

  &.company {
    @include limit-line-numbers(2);
  }
}

// 暂无活动
.tip-container {
  position: absolute;
  top: 43%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 718px;
  @include mobile {
    width: 92vw;
    position: static;
    margin-top: 30vw;
    margin-bottom: -15vw;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .iconfont.icon-empty {
      font-size: 64px;
      color: rgba($primary3, 0.25);
    }
    .warn-tip {
      font-size: 18px;
      color: rgba(178, 178, 178, 1);
    }
  }
}
</style>
